module.exports = __webpack_public_path__ + "img/icon_table_no_gift.ee703543.svg";